/* ============================================================
   Mesmerize native PDP blocks — behaviour layer
   <mes-countdown>  evergreen per-session countdown + progress bar
   <mes-tabs>       accessible tab switching
   [data-mes-flag]  ISO country code -> flag emoji
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Countdown ---------- */
  class MesCountdown extends HTMLElement {
    connectedCallback() {
      this.duration = Math.max(1, parseInt(this.dataset.duration, 10) || 0);
      this.onComplete = this.dataset.complete || 'hide';
      this.progressStart = Math.min(100, Math.max(0, parseFloat(this.dataset.progressStart) || 0));
      this.digitsEl = this.querySelector('[data-digits]');
      this.barEl = this.querySelector('[data-bar]');
      this.deadline = this.resolveDeadline();
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    storageKey() { return 'mes-cd-' + this.duration; }
    resolveDeadline() {
      var key = this.storageKey(), now = Date.now();
      try {
        var saved = parseInt(sessionStorage.getItem(key), 10);
        if (saved && saved > now) return saved;
        if (saved && saved <= now && this.onComplete !== 'repeat') return saved; /* keep expired so hide persists */
      } catch (e) {}
      var deadline = now + this.duration * 1000;
      try { sessionStorage.setItem(key, String(deadline)); } catch (e) {}
      return deadline;
    }
    tick() {
      var remaining = Math.round((this.deadline - Date.now()) / 1000);
      if (remaining <= 0) {
        if (this.onComplete === 'repeat') {
          this.deadline = Date.now() + this.duration * 1000;
          try { sessionStorage.setItem(this.storageKey(), String(this.deadline)); } catch (e) {}
          remaining = this.duration;
        } else {
          clearInterval(this.timer);
          this.hidden = true;
          return;
        }
      }
      if (this.digitsEl) this.digitsEl.textContent = this.format(remaining);
      if (this.barEl) {
        var pct = this.progressStart + (100 - this.progressStart) * (1 - remaining / this.duration);
        this.barEl.style.setProperty('--mes-cd-progress', pct.toFixed(2) + '%');
        this.barEl.style.width = pct.toFixed(2) + '%';
      }
    }
    format(s) {
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var mm = String(m).padStart(2, '0'), ss = String(sec).padStart(2, '0');
      return h > 0 ? h + ':' + mm + ':' + ss : mm + ':' + ss;
    }
  }
  if (!customElements.get('mes-countdown')) customElements.define('mes-countdown', MesCountdown);

  /* ---------- Tabs ---------- */
  class MesTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }
    onClick(e) {
      var tab = e.target.closest('[role="tab"]');
      if (tab) this.select(this.tabs.indexOf(tab));
    }
    onKeydown(e) {
      var tab = e.target.closest('[role="tab"]');
      if (!tab) return;
      var i = this.tabs.indexOf(tab);
      if (e.key === 'ArrowRight') { e.preventDefault(); this.select((i + 1) % this.tabs.length, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.select((i - 1 + this.tabs.length) % this.tabs.length, true); }
    }
    select(i, focus) {
      this.tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        t.tabIndex = i === j ? 0 : -1;
      });
      this.panels.forEach(function (p, j) { p.hidden = i !== j; });
      if (focus) this.tabs[i].focus();
    }
  }
  if (!customElements.get('mes-tabs')) customElements.define('mes-tabs', MesTabs);

  /* ---------- ISO country code -> flag emoji ---------- */
  function isoToFlag(iso) {
    if (!iso || iso.length !== 2) return '';
    var A = 0x1F1E6;
    return String.fromCodePoint(A + iso.charCodeAt(0) - 65, A + iso.charCodeAt(1) - 65);
  }
  function applyFlags() {
    document.querySelectorAll('[data-mes-flag]').forEach(function (el) {
      var iso = (el.getAttribute('data-mes-flag') || '').toUpperCase();
      var flag = isoToFlag(iso);
      if (flag) el.textContent = flag;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFlags, { once: true });
  else applyFlags();
})();
